import React from "react";
export default function TotalOrders() {
    const totalOrders = 12500;
    const leftCards = [
        {
            img: "https://cdn-icons-png.flaticon.com/512/4333/4333609.png",
            title: "Complete shopping Hub",
            price: "You can find a wide variety of products, services, and brands all in one convenient location",
        },
        {
            img: "https://cdn-icons-png.flaticon.com/512/1040/1040230.png",
            title: "Unbeatable Price & Quality ",
            price: "Best possible products at prices that competitors cannot match",
        },
    ];
    const rightCards = [
        {
            img: "https://cdn-icons-png.flaticon.com/512/4140/4140048.png",
            title: "Exclusive collection",
            price: "Unique and Varitey range of products that are specially curated and not widely available elsewhere",
        },
        {
            img: "https://cdn-icons-png.flaticon.com/512/833/833472.png",
            title: "One shop for Daily wear",
            price: "Destination where you can find everything you need for any occasion and daily wear",
        },
    ];
    return (
        <div className="section-header">
            <div>
                <h2>Why Choose Us?</h2>
            </div>
            <div className="total-orders-section">
                <div className="stats-layout">
                    <div className="side-grid">
                        {leftCards.map((card, index) => (
                            <div key={index} className="image-card">
                                <img src={card.img} alt={card.title} />
                                <p>{card.title}</p>
                                <p>{card.price}</p>
                            </div>
                        ))}
                    </div>
                    <div className="center-card">
                        <h2>Little Smiles Delivered So Far 🩷</h2>
                        <div className="orders-count">
                            {totalOrders.toLocaleString()}
                        </div>
                        <p>Trusted by thousands of happy customers</p>
                    </div>
                    <div className="side-grid">
                        {rightCards.map((card, index) => (
                            <div key={index} className="image-card">
                                <img src={card.img} alt={card.title} />
                                <p>{card.title}</p>
                                <p>{card.price}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}